module.exports = "<!-- View/routes wrapper-->\n<ng2-toasty position=\"top-right\">\n    </ng2-toasty>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/blank.template.html
// module id = ./src/app/components/common/layouts/blank.template.html
// module chunks = main